import { OreCardContainer, OreCardWrapper, OreStack, OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import Bill from '@/Shared/ui/assets/tpv-bill.png'
import { storesTranslation } from '@/Store/ui/storesTranslation'

export const TpvsGuide = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <OreCardContainer>
      <OreCardWrapper>
        <OreStack direction="column" space="medium">
          <OreText size="text-md" tone="neutral-900">
            {t(storesTranslation.tpvs.guide.description)}
          </OreText>
          <OreStack placeContent="center">
            <img src={Bill} alt="ticket"></img>
          </OreStack>
        </OreStack>
      </OreCardWrapper>
    </OreCardContainer>
  )
}
